import { ReactNode } from 'react'
import Footer from '../landing/components/Footer'

export default function PageLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-oak-cream">
      {children}
      <Footer />
    </div>
  )
}
